export default {
  satelliteReport: {
    satelliteReport: "Rapporti satellitari",
    generateReport: "Generare un nuovo rapporto",
    satelliteReportTooltip:
      "Qui è possibile ottenere 5 repot satellitari di base per le vostre aziende agricole (NDVI, MSAVI, NDRE, RECI, LSWI) per valutare la salute delle colture a base di Nutriente e umidità livelli",
    operatorName: "Nome operatore",
    issueDate: "Data di pubblicazione",
    selectFarm: "Seleziona Agriturismo",
    chooseFarm: "Scegli Agriturismo",
    chooseZone: "Scegli zona",
    genReport: "Rapporto generazionale",
    viewReport: "Visualizza relazione",
    farmName: "Nome dell'azienda",
    allFarms: "Tutti gli agriturismi",
    zone: "Area(i)",
    selectReportType: "Selezionare Tipo di relazione",
    report: "Relazione",
    cropHealth: "Salute del raccolto (NDVI)",
    doi: "Data di interesse",
    dateOfImage: "Data di immagine con bassa copertura cloud",
    reciValues: "Valori RECI Gamma da 0 a 10",
    ndviValues: "Valori NDVI",
    rangeSubtitle: "I valori vicini a 1 indicano una vegetazione più sana",
  },
  deforestation: {
    producerData: {
      addProducers: "AGGIUNGI NUOVO PRODUTTORE",
      countryInfo:
        "Campo per inserire o visualizzare il paese associato a un produttore.",
    },
    selectFileToUpload: "Seleziona il file per caricare i dati",
    uploadedToEU: "Caricato sul portale dell'UE",
    pending: "In sospeso",
    underReview: "In revisione",
    compliant: "Conforme",
    nonCompliant: "Non conforme",
    analyzeDeforestation: "Analizzando la deforestazione",
    analyzingDeforestation: "Analizzando la deforestazione",
    readyToProceed: "Pronto a procedere",
    processingFarm: "Elaborazione della fattoria",
    mitigationRequired: "Mitigazione richiesta",
    pendingApproval: "In attesa di approvazione",

    veryHighDeforestationProbability:
      "Probabilità di deforestazione molto alta",
    highDeforestationProbability: "Probabilità di deforestazione alta",
    mediumDeforestationProbability: "Probabilità di deforestazione media",
    lowDeforestationProbability: "Probabilità di deforestazione bassa",
    veryLowDeforestationProbability:
      "Probabilità di deforestazione molto bassa",
    zeroNegligibleDeforestationProbability:
      "Probabilità di deforestazione zero/negligibile",
    manuallyMitigated: "Mitigato manualmente",

    selectCountry: "Seleziona Paese",
    internalReferenceNumberMustBeAlphanumeric:
      "Il numero di riferimento interno deve essere alfanumerico",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired:
      "È richiesto almeno uno tra ID Fornitore o Nome Fornitore",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired:
      "È richiesto almeno uno tra ID Operatore o Nome Operatore",
    netMassIsRequired: "La massa netta è obbligatoria",
    netMassMustBeValid: "La massa netta deve essere valida",
    thisFieldIsRequired: "Questo campo è obbligatorio",
    volumeMustBeNumeric: "Il volume deve essere numerico",
    nameIsRequired: "Il nome è obbligatorio",
    lastNameIsRequired: "Il cognome è obbligatorio",
    firstNameIsRequired: "Il nome è obbligatorio",
    countryIsRequired: "Il paese è obbligatorio",

    confirmPdfDownload: "Desideri scaricare tutti gli allegati in formato PDF?",
    confirmJsonDownload:
      "Desideri scaricare tutti gli allegati in formato JSON?",
    basicFinalFarmListWithStatus: "Elenco finale di fattorie di base con stato",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities:
      "Informazioni dettagliate, inclusa la descrizione delle attività di mitigazione del rischio",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments:
      "Documento completo, inclusa la mitigazione del rischio e i documenti allegati",

    existing: "Esistente",
    survey: "Sondaggio",

    operatorInformation: "Informazioni sull'Operatore",
    addNewOperator: "Aggiungi un Nuovo Operatore",

    reportAddedSuccessfully: "Report aggiunto con successo",
    reportUpdatedSuccessfully: "Report aggiornato con successo",
    itemDeletedSuccessfully: "Elemento eliminato con successo.",
    reportDeletedSuccessfully: "Report eliminato con successo",
    anErrorOccurredWhileDeletingTheReport:
      "Si è verificato un errore durante l'eliminazione del report.",

    valueMustBeBetween02And40: "Il valore deve essere compreso tra 0,2 e 40",

    EUDRDeforestationStatusTT:
      "Selezione dello stato di deforestazione. Alta Probabilità di Deforestazione: Una categoria specifica di valutazione del rischio assegnata ad aree geografiche in base alla probabilità di deforestazione o degrado forestale. Aiuta a determinare i requisiti di due diligence per gli operatori che immettono sul mercato dell'UE materie prime rilevanti (come cacao, caffè, ecc.) o prodotti che li contengono o che ne sono composti. Bassa Probabilità di Deforestazione: Una categoria di valutazione del rischio assegnata ad aree geografiche considerate poco soggette a deforestazione o degrado forestale significativo. Questa designazione influenza i requisiti di due diligence per gli operatori che immettono sul mercato dell'UE materie prime o prodotti provenienti da queste aree. Probabilità Nulla/Insignificante di Deforestazione: Una probabilità molto bassa o inesistente di deforestazione. Indica che il rischio o l'impatto della deforestazione è considerato estremamente basso o insignificante.",

    complianceRiskWarnings: "Avvisi di Rischio di Conformità",
    complianceRiskWarningsInfo:
      "Mostra il titolo della sezione, indicando che quest'area si concentra sugli avvisi relativi ai rischi di conformità nel processo di due diligence.",
    locationVerificationTT:
      "Si riferisce al processo di conferma e convalida della posizione geografica dei siti di produzione come parte delle procedure di due diligence. Implica garantire che i dettagli della posizione forniti, come coordinate o indirizzo, rappresentino accuratamente il luogo fisico in cui avvengono le attività produttive. Questa verifica è essenziale per valutare gli impatti ambientali, la conformità all'uso del suolo e l'accuratezza dei dati riportati nel rapporto di due diligence.",

    netMassKg: "Massa Netta (kg)",
    volumeM3: "Volume (m3)",
    warning: "Avviso",

    productionPlacesTT: "Luoghi in cui vengono prodotti o coltivati beni.",
    productionPlacesCountryInfo:
      "Un corpo territoriale distinto con il proprio governo e confini.",
    productionPlacesProducersInfo:
      "Entità responsabile della creazione o della coltivazione di beni.",
    totalsTT:
      "La sezione 'Totali' fornisce un riepilogo dei principali indicatori quantitativi per l'intero set di dati o rapporto. Aggrega i dati per offrire agli utenti una panoramica rapida delle metriche complessive, come la massa totale del prodotto, il volume totale del prodotto, l'area del luogo di produzione, ecc., coinvolti nel rapporto di due diligence.",

    AnalysisOfDeforestationStatusTT:
      "Analisi dello stato attuale della deforestazione in un'area specifica, solitamente condotta per valutare l'impatto ambientale o la conformità agli sforzi di conservazione.",

    complete: "Completo",

    undoDelete: "Annulla Eliminazione",

    verifyingLocationsData: "Verifica dei dati delle posizioni in corso...",
    crossCheckingWithProductionPlaces:
      "Controllo incrociato con i luoghi di produzione...",
    almostTherePleaseHoldOn: "Quasi fatto, per favore attendi...",
    LocationVerifiedSuccessfully: "Posizione(i) verificata con successo!",
    allProductionPlacesAndLocationsHaveBeenConfirmed:
      "Tutti i luoghi di produzione e le posizioni sono stati confermati!",
    errorCheckingOverlaps: "Errore nel controllare le sovrapposizioni.",
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon:
      "La fattoria è più grande di 4 ettari, deve essere un poligono",
    failedToFetchSettings:
      "Impossibile recuperare le impostazioni. Controlla le tue impostazioni o contatta l`assistenza se il problema persiste.",
    farmCountryNotDefined: "Paese della fattoria non definito.",
    theGeofencesSupposeToBeIn: "La recinzione geofisica dovrebbe essere in",
    butItsIn: "ma si trova in",
    geofenceIsInOcean: "La recinzione geofisica o parte di essa è nell’oceano.",

    existingReport: "Rapporto di deforestazione esistente",
    dimitraReport: "Rapporto di deforestazione Dimitra",

    anErrorOccuredWhileFetchingTheDeforestationReport:
      "Si è verificato un errore durante il recupero del rapporto di deforestazione.",

    attachRiskMigrationDocTT:
      "Indica l'azione di collegare un unico documento a tutte le fattorie identificate come a rischio di deforestazione, generalmente per scopi di documentazione o conformità normativa.",
    oneForAllFarms: "Uno per Tutte le Fattorie",
    oneForEachFarm: "Uno per Ogni Fattoria",
    uploadExistingAssessment: "Carica Valutazione Esistente",
    completeDimitraAssessment: "Valutazione da parte dell'Operatore o Fornitore",
    assessmentByFarmer: "Valutazione da parte dell'Agricoltore",
    "Zero/Negligible Deforestation Probability":
      "Probabilità di deforestazione zero/negligible",
    "Zero Deforestation Probability": "Probabilità della deforestazione zero",
    "Low Deforestation Probability": "Bassa probabilità di deforestazione",
    "High Deforestation Probability": "Alta probabilità di deforestazione",
    "Very Low Deforestation Probability":
      "Probabilità di deforestazione molto bassa",
    "Medium Deforestation Probability": "Probabilità media di deforestazione",
    "Very High Deforestation Probability":
      "Probabilità di deforestazione molto elevata",
    disputeReason: "Motivazione della disputa",
    farmRegId: "Farm Reg. Id",
    productionPlaceId: "Prod. ID luogo",
    disputeId: "ID di disputa",
    disputeResolution: "Risoluzione delle controversie",
    disputeStatus: "Stato della disputa",
    disputeArea: "Dimensione dell'area",
    selectDefaultMeasurementUnit: "Seleziona unità di misura predefinite",
    selectDefaultMeasurementUnitInfo:
      "Consente la selezione delle unità di misura predefinite, inclusa la specifica dell'unità, l'impostazione di un limite massimo e la marcatura come opzione predefinita.",
    maxLimit: "Limite massimo",
    maxLimitInfo:
      "Imposta il valore massimo consentito o la soglia per un determinato parametro.",
    asDefault: "Imposta come predefinito",
    productMass: "Massa del prodotto",
    productMassUnitInfo:
      "Specifica l'unità per misurare la massa di un prodotto.",
    volumeUnitInfo: "Specifica l'unità per misurare il volume di un prodotto.",
    operatorInfo:
      "Si riferisce a un individuo o entità responsabile della gestione o dell'operazione di un sistema o processo.",
    supplierInfo: "Un'entità che fornisce beni o servizi a un'altra entità.",
    userTypeInfo:
      "Classifica individui o entità in base al loro ruolo o permessi all'interno del sistema.",
    unit: "Unità",
    userType: "Tipo di utente",
    eudrPortalApiKeys: "Chiavi API del portale EUDR",
    apiKey: "Chiave API",
    apiSecret: "Segreto API",
    headingOrderSuccessfullyUpdated:
      "Ordine dell'intestazione aggiornato con successo",
    orderSuccessfullyUpdated: "Ordine aggiornato con successo",
    headingUpdatedSuccessfully: "Intestazione aggiornata con successo",
    questionTypeNotDefined: "Tipo di domanda non definito",
    assessmentRiskMitigationLvl:
      "Livelli di mitigazione del rischio di valutazione",
    assessmentRiskMitigationLvlInfo:
      "Classifica la gravità dei rischi associati all'uso del suolo, alle pratiche forestali e all'espansione agricola. Questi livelli aiutano a identificare l'impatto potenziale delle attività nelle aree boschive e guidano le azioni appropriate per mitigare le conseguenze negative. Classifica i livelli delle strategie di mitigazione del rischio, tra cui molto alto, alto, medio, basso e zero/neglibile.",

    dynamicExpiryTime: "Periodo di scadenza dinamico",
    dynamicExpiryTimeInfo:
      "Imposta un periodo di tempo dopo il quale determinati dati o impostazioni scadono automaticamente. Configura le impostazioni relative ai rapporti sulla deforestazione, comprese le opzioni per il rinnovo automatico.",
    eudrDeforestationAssessment: "Valutazione della deforestazione EUDR",
    autoRenewalIf:
      "Rinnovo automatico all'aggiunta al rapporto di due diligence",
    declarationStatements: "Dichiarazioni",
    declarationStatementsInfo:
      "Dichiarazioni rilasciate dalla parte responsabile certificando l'accuratezza, la completezza e l'autenticità delle informazioni contenute nel rapporto.",
    filterDeclaration: "Filtra dichiarazioni",
    declarationTitle: "Titolo della dichiarazione",
    declarationTitleInfo:
      "Titolo o intestazione per una dichiarazione, fornendo contesto o riassumendo il suo contenuto.",
    applicableCountry: "Paesi applicabili",
    applicableCountryInfo:
      "Elenca i paesi a cui si applicano determinate impostazioni o regolamenti.",
    addMore: "Aggiungi altro",
    autoRenewal: "Rinnovo automatico",
    createNewAssessment: "Crea nuova valutazione",
    userDimitraAssessment: "Usa valutazioni Dimitra",
    eudrComplianceStatus: "Utilizza le valutazioni Dimitra",
    shipmentList: "Elenco spedizioni",
    generalData: "Dati generali",
    check: "Controlla",
    deforestationComplianceReport: "Rapporti di conformità alla deforestazione",
    noDeforestationComplianceReport:
      "Nessun rapporto di conformità alla deforestazione trovato",
    loadingDeforestationComplianceReport:
      "Caricamento rapporto di conformità alla deforestazione",
    farmName: "Nome della fattoria",
    farmRegistrationId: "ID di registrazione della fattoria",
    farmerName: "Nome del contadino",
    farmerRegistrationId: "ID di registrazione del contadino",
    uniqueFarmerId: "ID unico del contadino",
    uniqueFarmId: "ID unico della fattoria",
    farmLocation: "Posizione della fattoria",
    area: "Area",
    farmAddress: "Indirizzo della fattoria",
    dateOfRequest: "Data della richiesta",
    status: "Stato",
    settings: "Impostazioni",

    farmLatitude: "Latitudine della fattoria",
    farmLongitude: "Longitudine della fattoria",
    shareQRCode: "Condividi codice QR",
    copy: "Copia",

    allCountries: "Tutti i paesi",
    allRegions: "Tutte le regioni",
    allFarms: "Tutte le fattorie",
    viewCertificate: "Visualizza certificato",

    assignmentIssued: "Assegnazione emessa",

    complianceCertification: "Certificazione di conformità",
    noComplianceCertification: "Nessuna certificazione di conformità trovata",
    loadingComplianceCertification: "Caricamento certificazione di conformità",

    eudrForestAssessment: "Valutazioni forestali EUDR",
    assessmentReport: "Rapporto di valutazione",
    downloadPDF: "Scarica PDF",
    back: "Indietro",
    farmDetails: "Dettagli della fattoria",

    dimitraFarmId: "ID della fattoria Dimitra",
    dimitraFermerId: "ID del contadino Dimitra",

    totalGeofenceAreaHA: "Area totale della georecinzione (HA)",
    forestLossHA: "Perdita forestale (HA)",
    forestGainHA: "Guadagno forestale (HA)",
    forestUnchangedHA: "Foresta invariata (HA)",
    shareCertificate: "Condividi certificato",
    forestUnchanged: "Foresta invariata",
    forestLoss: "Perdita forestale",
    forestGain: "Guadagno forestale",
    totalGeofenceArea: "Area totale della georecinzione",
    print: "Stampa",
    deforestationProbability: "Probabilità di deforestazione",
    colorCode: "Codice colore",
    geofenceArea: "Area della georecinzione",
    percentageOfGeofenceArea: "Percentuale dell'area della georecinzione",
    view: "Visualizza",
    customization: "Personalizzazione",
    recordsPerpage: "Record per pagina",
    restoreDefault: "Ripristina valori predefiniti",
    apply: "Applica",
    forestAssessmentHelp:
      "Se hai domande su questo rapporto o hai bisogno di aiuto per capirlo, contattaci tramite il servizio di assistenza.",
    overallDeforestationProbability:
      "Probabilità complessiva di deforestazione",
    zeroOrNegligible: "Zero/Trascurabile",
    high: "Alta",
    allStatus: "Tutti gli stati",
    low: "Bassa",
    veryHigh: "Molto alta",
    medium: "Media",
    veryLow: "Molto bassa",
    assessmentIssued: "Valutazione emessa",
    certificateIssued: "Certificato emesso",
    assessmentNo: "Numero di valutazione",
    blockchainCertificateDesc:
      "L'hash di validazione del certificato blockchain sarà disponibile dopo l'accettazione del certificato",
    blockchainValidation: "Validazione del certificato blockchain",
    openBlockchainPage: "Apri pagina blockchain",
    clickLinkDesc:
      "Clicca sul link sopra per validare il certificato sulla blockchain",
    tooltip: {
      dimitraFarmId:
        "Identificatore unico associato a una fattoria specifica nel sistema Dimitra.",
      farmName: "Il nome designato della fattoria.",
      farmRegistrationId: "Numero di registrazione della fattoria.",
      farmLocation:
        "Coordinate geografiche specifiche o posizione della fattoria.",
      dimitraFermerId:
        "Un identificatore distinto associato a un contadino nel sistema Dimitra.",
      farmerName: "Identificazione della persona responsabile della fattoria.",
      farmerRegistrationId: "Numero di registrazione del contadino.",
      assessmentNo: "Numero unico assegnato alla valutazione.",
    },
    red: "Rosso",
    yellow: "Giallo",
    transparent: "Trasparente",
    darkRed: "Rosso scuro",
    brightRed: "Rosso brillante",
    orange: "Arancione",
    lightBlue: "Azzurro",
    teal: "Verde acqua",
    zeroOrNegligibleProbability:
      "Probabilità di deforestazione zero/trascurabile",
    riskDetected: "Rischio rilevato",
    zeroOrNegligibleRisk: "Rischio zero/trascurabile",
    veryLowProbability: "Probabilità di deforestazione molto bassa",
    lowProbability: "Probabilità di deforestazione bassa",
    mediumProbability: "Probabilità di deforestazione media",
    highProbability: "Probabilità di deforestazione alta",
    veryHighProbability: "Probabilità di deforestazione molto alta",
    zeroOrNeglegible: "Zero o trascurabile",
    High: "Alta",
    Low: "Bassa",

    zeroOrNeglegibleProbability:
      "Probabilità di deforestazione zero/trascurabile",
    very_high: "Molto alta",
    very_low: "Molto bassa",
    Orange: "Arancione",
    locationName: "Nome della posizione",
    dueDeligence: "Devida Deligência",
    supplierInformation: "Informazioni sul fornitore",
    addNewSupplier: "Aggiungi nuovo fornitore",
    name: "Nome",
    lastName: "Cognome",
    email: "Indirizzo email",
    phoneNumber: "Numero di telefono",
    enterSupplierName: "Inserisci il nome del fornitore",
    enterSupplierLastName: "Inserisci il cognome del fornitore",
    enterSupplierFirstName: "Inserisci il nome del fornitore",
    enterOperatorName: "Inserisci il nome dell'operatore",
    enterEmailAddress: "Inserisci l'indirizzo email",
    enterPhoneNumber: "Inserisci il numero di telefono",
    whoWillAddPlace: "Chi aggiungerà i dati del luogo di produzione?",
    companyId: "ID dell'azienda",
    activity: "Attività",
    placeOfActivity: "Luogo dell'attività",
    countryOfActivity: "Paese dell'attività",
    operatorPlaceOfActivity: "Luogo di Attività dell'Operatore",
    operatorCountryOfActivity: "Paese di Attività dell'Operatore",
    countryOfEntry: "Paese di entrata",
    productDetail: "Dettagli del prodotto",
    subProduct: "Sotto-prodotto",
    productionDescription: "Descrizione del prodotto",
    netMass: "Massa netta",
    volume: "Volume",
    scietificName: "Nome scientifico",
    commonName: "Nome comune",
    eudrDueDeligenceReports: "Rapporti di due diligence EUDR",
    EUDRAssessmentReports: "Rapporti di valutazione EUDR",
    supplierName: "Nome del fornitore",
    supplierContactInfo: "Informazioni di contatto del fornitore",
    supplierAddress: "Indirizzo del fornitore",
    addNew: "Aggiungi nuovo",
    reportGenerated: "Rapporto generato",
    reportStatus: "Stato del rapporto",
    approvalStatus: "Stato di approvazione",
    documentType: "Tipo di documento",
    addDocument: "Aggiungi documento",
    documentList: "Elenco documenti",
    documentName: "Nome documento",
    uploadDocument: "Carica documento",
    documentUploaded: "Documento caricato",
    noDocumentsFound: "Nessun documento trovato",
    loadingDocuments: "Caricamento documenti...",
    viewDocument: "Visualizza documento",
    documentDescription: "Descrizione documento",
    dateUploaded: "Data di caricamento",
    selectFile: "Seleziona file",
    deleteDocument: "Elimina documento",
    confirmDeleteDocument: "Sei sicuro di voler eliminare questo documento?",
    yes: "Sì",
    no: "No",
    backToDashboard: "Torna alla dashboard",
    newSupplier: "Nuovo fornitore",
    existingSupplier: "Fornitore esistente",
    enterSupplierDetails: "Inserisci i dettagli del fornitore",
    contactPerson: "Persona di contatto",
    contactPosition: "Posizione di contatto",
    addContact: "Aggiungi contatto",
    contactList: "Elenco contatti",
    noContactsFound: "Nessun contatto trovato",
    loadingContacts: "Caricamento contatti...",
    viewContact: "Visualizza contatto",
    editContact: "Modifica contatto",
    deleteContact: "Elimina contatto",
    confirmDeleteContact: "Sei sicuro di voler eliminare questo contatto?",
    reportTitle: "Titolo del rapporto",
    reportDescription: "Descrizione del rapporto",
    generateReport: "Genera rapporto",
    reports: "Rapporti",
    reportList: "Elenco rapporti",
    noReportsFound: "Nessun rapporto trovato",
    loadingReports: "Caricamento rapporti...",
    viewReport: "Visualizza rapporto",
    editReport: "Modifica rapporto",
    deleteReport: "Elimina rapporto",
    confirmDeleteReport: "Sei sicuro di voler eliminare questo rapporto?",
    history: "Storia",
    actionHistory: "Storico azioni",
    noHistoryFound: "Nessuna storia trovata",
    loadingHistory: "Caricamento della storia...",
    filterByDate: "Filtra per data",
    filterByAction: "Filtra per azione",
    selectDate: "Seleziona data",
    applyFilter: "Applica filtro",
    clearFilter: "Pulisci filtro",
    downloadReport: "Scarica rapporto",
    printReport: "Stampa rapporto",
    exportAsCSV: "Esporta come CSV",
    exportAsPDF: "Esporta come PDF",
    uploadNewDocument: "Carica nuovo documento",
    noDocumentUploaded: "Nessun documento caricato",
    selectDocumentType: "Seleziona tipo di documento",
    addComment: "Aggiungi commento",
    comments: "Commenti",
    noCommentsFound: "Nessun commento trovato",
    loadingComments: "Caricamento commenti...",
    editComment: "Modifica commento",
    deleteComment: "Elimina commento",
    confirmDeleteComment: "Sei sicuro di voler eliminare questo commento?",
    commentPosted: "Commento inviato",
    postComment: "Pubblica commento",
    supplierAssessment: "Valutazione del fornitore",
    noAssessmentsFound: "Nessuna valutazione trovata",
    loadingAssessments: "Caricamento valutazioni...",
    viewAssessment: "Visualizza valutazione",
    editAssessment: "Modifica valutazione",
    deleteAssessment: "Elimina valutazione",
    confirmDeleteAssessment:
      "Sei sicuro di voler eliminare questa valutazione?",
    createNewReport: "Crea nuovo rapporto",
    submit: "Invia",
    cancel: "Annulla",
    saveChanges: "Salva modifiche",
    uploadCompleted: "Caricamento completato",
    selectSupplier: "Seleziona fornitore",
    supplierType: "Tipo di fornitore",
    newSupplierRegistration: "Registrazione nuovo fornitore",
    existingSupplierDetails: "Dettagli fornitore esistente",
    viewDetails: "Visualizza dettagli",
    generalSettings: "Impostazioni generali",
    supplierPolicy: "Politica sui fornitori",
    addPolicy: "Aggiungi politica",
    policyList: "Elenco politiche",
    noPoliciesFound: "Nessuna politica trovata",
    loadingPolicies: "Caricamento politiche...",
    viewPolicy: "Visualizza politica",
    editPolicy: "Modifica politica",
    deletePolicy: "Elimina politica",
    confirmDeletePolicy: "Sei sicuro di voler eliminare questa politica?",
    policyDescription: "Descrizione della politica",
    policyTitle: "Titolo della politica",
    createPolicy: "Crea politica",
    updatePolicy: "Aggiorna politica",
    policyDetails: "Dettagli politica",
    reportGeneratedSuccessfully: "Rapporto generato con successo",
    reportFailedToGenerate: "Impossibile generare il rapporto",
    userProfile: "Profilo utente",
    accountSettings: "Impostazioni account",
    updateProfile: "Aggiorna profilo",
    changePassword: "Cambia password",
    logout: "Disconnetti",
    dashboard: "Cruscotto",
    home: "Home",
    analytics: "Analitica",
    notifications: "Notifiche",
    help: "Aiuto",
    feedback: "Feedback",
    operator: "Operatore",
    supplier: "Fornitore",
    language: "Lingua",
    dueDeligenceReport:
      "Impostazioni del rapporto pubblico di due diligence",
    allowPublicDownload:
      "Consenti il download pubblico delle geofence delle aziende agricole in formato GeoJson",
    showDeforestationSummary:
      "Mostra il riepilogo del rischio di deforestazione EUDR per categoria",
    createShipment: "Crear Envío",
    actions: "Acciones",
    disabled: "Disabili",
    enabled: "Abilitato",

    exporter: "Exportatore",
    exporterInfo:
      "Nome dell'esportatore. L'entità o la parte responsabile dell'esportazione dei beni.",
    importer: "Importatore",
    importerInfo:
      "Nome dell'importatore. L'entità o la parte responsabile dell'importazione dei beni.",
    shipmentReferenceNo: "N. di riferimento della spedizione",
    shipmentReferenceNoInfo:
      "Un identificatore univoco utilizzato per fare riferimento alla spedizione.",
    ownerShipType: "Tipo di proprietà",
    ownerShipTypeInfo: "Il tipo di proprietà associata alla spedizione.",
    buyerName: "Nombre del Comprador",

    buyer: "Compratore",
    port_of_origin: "Porto di Origine",
    port_of_origin_info: "La posizione da cui proviene la spedizione.",
    port_of_destination: "Porto di Destinazione",
    port_of_destination_info:
      "Il porto di destinazione previsto per la spedizione.",
    no_of_stops: "Nº di Fermate",
    shipping_line: "Linea di Navigazione",
    shipping_line_info:
      "La compagnia o entità responsabile per il trasporto della spedizione.",
    expected_arrival_date: "Data di Arrivo Prevista",
    expected_arrival_date_info:
      "Data di arrivo prevista per la spedizione alla sua destinazione.",
    container_id: "ID del Contenitore",
    container_id_info:
      "Identificatore unico per il contenitore di spedizione utilizzato nella spedizione.",
    container_type: "Tipo di Contenitore",
    container_type_info:
      "Il tipo o la categoria del contenitore di spedizione.",
    container_size: "Dimensione del Contenitore (ft)",
    container_size_info: "Le dimensioni fisiche del contenitore di spedizione.",
    container_capacity: "Capacità del Contenitore (Tonnellate)",
    container_capacity_info:
      "Il carico massimo o la capacità del contenitore di spedizione.",
    eudr_reference_number: "Nº di Riferimento EUDR",
    eudrRefNo: "Nº di Riferimento EUDR",
    eudrRefNoInfo:
      "Funzionalità per trovare informazioni specifiche relative alla spedizione.",
    statusInfo:
      "Lo stato attuale della spedizione in relazione al rapporto di due diligence.",
    eudrAndInternalRefNo: "N. di Riferimento EUDR / Interno",
    exporterAndSupplier: "Esportatore e Fornitore",
    internalRefNo: "N. di Riferimento Interno",
    quantity: "Quantità",
    product: "Prodotto",
    noOfFarms: "No. delle aziende agricole",
    farmsAndQuantity: "Fattorie e quantità",
    country: "Paese",
    lastUpdated: "Ultimo aggiornamento",
    dueDeligenceStatus: "Stato di due diligence",
    edurDueDeligenceStatus: "Stato di due diligence EUDR",
    edurDueDeligenceReport: "Rapporto di due diligence EUDR",
    reject: "Rifiuti",
    discard: "Discorso",
    saveAndContinueLater: "Salvare e continuare Più tardi",
    requestAdditionalInformation: "Richiedi informazioni aggiuntive",
    requestAdditionalInformationShort: "Richiedi maggiori informazioni",
    uploadToEudr: "Caricamento in EUDR",
    productionPlaces: "Luoghi di produzione",
    allProducer: "Tutti i produttori",
    next: "Il prossimo",
    dueDeligenceReportCreation: "Due Diligence Report Creazione",
    producer: "Produttore",
    select: "Seleziona",
    productionPlacesFarmAndFarmId: "Luogo di produzione(Farm) & farm Id",
    producerName: "Nome del produttore",
    addressOfProduction: "Indirizzo di Produzione",
    type: "Tipo",
    geofence: "Geofence",
    areaHa: "Superficie (ha)",
    editGeofence: "Edit Geofence",
    totals: "Totale",
    farm: "Fattoria",
    locationVerification: "Verifica della posizione",
    AnalysisOfDeforestationStatus: "Analisi dello stato di deforestazione",
    EUDRDeforestationStatus: "Stato di disboscamento dell'UEDR",
    removeAllLowRiskFarm: "Rimuovere tutte le fattorie a basso rischio",
    removeAllHighRiskFarm: "Rimuovere tutte le fattorie ad alto rischio",
    removeAllMediumRiskFarm: "Rimuovere tutte le fattorie a rischio medio",
    attachRiskMigrationDoc:
      "Attaccare un documento di mitigazione del rischio per tutte le fattorie ad alto rischio",
    removedFarms: "Fattoria rimossa dalla lista",
    generateCertificate: "Generate Certificate",
    viewDisputeHistory: "Visualizza cronologia delle controversie",
    disputeAssessment: "Valutazione delle controversie",
    reportDetails: "Report dettagli",
    productionPlace: "Luogo di produzione",
    regionalRiskAssessment: "Valutazione del Rischio Regionale",
    EUDRDeforestationAssessment: "Valutazione della deforestazione EUDR",
    EUDRcountry:
      "Il paese in cui si trova l'azienda agricola, collegato al prodotto nel rapporto di due diligence. Aiuta a garantire la tracciabilità geografica come richiesto dalle normative EUDR.",
    riskAssessment: "Valutazione del rischio",
    legalInformation: "Informazioni legali",
    finalReport: "Relazione finale",
    editGeolocation: "Modifica",
    producerCountry: "Paese produttore",
    manuallyAddData: "Aggiungi manualmente i dati",
    drawGeofence: "Disegno Geofence",
    uploadFile: "Carica file",
    typeyourlocation: "Digitare il nome della posizione/indirizzo",
    numberOfPoints: "Numero di punti poligoni",
    viewGeolocation: "Visualizza Geolocalizzazione",
    geoLocation: "Geolocalizzazione",
    Point: "N",
    Circular: "Circolare",
    Polygon: "Poligono",
    selectFileToUploadData: "Selezionare un file per caricare i dati",
    loadingProductionPlaces: "Luoghi di produzione di caricamento",
    remove: "Rimuovi",
    restore: "Ripristino",
    riskMitigation: "Mitigazione del rischio",
    riskMitigationHistory: "Cronologia della mitigazione del rischio",
    signParticipationSurvey:
      "Vorresti gentilmente firmare digitalmente per confermare la tua partecipazione a questo sondaggio?",
    signedBy: "Firmato digitalmente da:",
    assessmentRiskMitigation: "Valutazione del rischio Mitigazione",
    submissionDate: "Data di ammissione",
    eudrReferenceNo: "Unione europea Numero di riferimento.",
    internalReferenceNo: "Riferimento interno n.",
    locationVerificationTab: {
      confirmationTitle: "Conferma",
      confirmationMessage:
        "Stai per modificare i dati di geolocalizzazione di questa fattoria. Si prega di notare che qualsiasi modifica alla geolocalizzazione richiederà la ri-verifica di tutti i passaggi correlati, inclusa la verifica della posizione, l'analisi della deforestazione e la valutazione del rischio regionale (controlli delle aree protette e indigene). Le modifiche al nome della fattoria o del contadino non richiederanno ri-verifica. Vuoi procedere?",
    },
    locationModified: {
      headerTitle: "Posizioni Modificate",
      headerDescription:
        "Abbiamo rilevato che le seguenti posizioni sono state modificate e devono essere verificate di nuovo.",
    },
    processingDialog: {
      modalHeader: "Analisi dello Stato della Deforestazione",
      modalDescription_first: "Analisi dello Stato della Deforestazione EUDR",
      modalDescription_second:
        "Le tue fattorie stanno subendo un'Analisi Automatizzata della Deforestazione. Sarai reindirizzato alla pagina dell'elenco dei Rapporti di Due Diligence per visualizzare lo stato.",
    },
    farmList: {
      title: "Elenco delle fattorie EUDR",
      addFarmGeofenceManually: "Aggiungi geofence della fattoria manualmente",
      importGeofenceInBulk: "IMPORTA GEO-CENCEN IN MASSA",
      searchPlaceHolder: "Cerca per nome del contadino",
      generateCertificate: "Genera Certificato",
      requestAssementReport: "Richiedi Rapporto di Valutazione",
      producer: "Produttore",
      farmNameAndId: "Nome e ID della fattoria",
      addressOfProduction: "Indirizzo di Produzione",
      registrationDate: "Data di Registrazione",
      eudrDeforestationStatus: "Stato della Deforestazione EUDR",
      riskAssessmentStatus: "Stato della Valutazione del Rischio",
      assessmentTitle: "Titolo della Valutazione",
      assessmentDescription: "Descrizione della Valutazione",
      submissionDate: "Data di Presentazione",
      expiryDate: "Data di Scadenza",
      assessmentStatus: "Stato della Valutazione",
      downloadAsKmx: "Scarica come KMX",
      downloadAsKml: "Scarica come KML",
      downloadAsShp: "Scarica come SHP",
      downloadAsCsv: "Scarica come CSV",
      downloadAsExcel: "Scarica come EXCEL",
      downloadAsPdf: "Scarica come PDF",
      downloadAsGeoJson: "Scarica come GeoJSON",
      loadingFarms: "Caricamento delle fattorie",
    },
    deforestationAssessmentRiskToleranceLevel:
      "Livello di Tolleranza al Rischio di Valutazione della Deforestazione",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Utilizza questo strumento per configurare quale % di deforestazione, per ogni valutazione, è accettabile all'interno del tuo processo di Valutazione del Rischio. Le fattorie con un rischio minore o uguale a quello definito saranno considerate idonee a rimanere nel DDS, senza la necessità di effettuare la Mitigazione del Rischio.",
    tons: "tonnellate",

    headingCreatedSuccessfully: "Intestazione creata con successo",
    failedToDeleteQuestion: "Impossibile eliminare la domanda",
    questionOrderSuccessfullyUpdated:
      "Ordine delle domande aggiornato con successo",
    assessmentUpdatedSuccessfully: "Valutazione aggiornata con successo",
    pleaseWaitCurrentlyUpdatingChecklist:
      "Attendere, aggiornamento della lista di controllo in corso",

    assessmentDetails: "Dettagli della valutazione",
    dontShowWarning: "Non mostrare più questo avviso.",
    dateSubmitted: "Data di invio",
    addAComment: "Aggiungi un commento",
    changeAssignee: "Cambia assegnatario",
    changeStatus: "Cambia stato",
    assignedUser: "Utente assegnato",
    selectAssignee: "Seleziona assegnatario",
    reply: "Rispondi",
    discussion: "Discussione",
    attachment: "Allegato",
    sizeKb: "Dimensione (KB)",
    dateAdded: "Data di aggiunta",
    shipmentStatus: "Stato della Spedizione",
    viewStops: "Visualizza Fermate",
    enRoute: "In Transito",
    delivered: "Consegnato",
    failed: "Fallito",
    download: "Scarica",
    removeEudrDeforestationStatus: "Rimuovi Stato di Deforestazione EUDR",
    riskAssessmentStatusIsRequired:
      "È necessario lo stato della valutazione del rischio",
      requestAdditionalInformationPage: {
        descriptionLabel: "Si prega di fornire commenti o istruzioni specifiche nella casella di testo sottostante. Una volta inviato, il fornitore verrà notificato e avrà accesso per modificare il rapporto di due diligence. Verrai avvisato quando il fornitore aggiornerà il rapporto.",
        shareAccessLabel: "Il fornitore attualmente non ha accesso a questo rapporto. Vuoi condividere l'accesso con il fornitore? Si prega di scegliere come si desidera condividere l'accesso:",
        shareCompleteReportLabel: "Condividi rapporto completo",
        shareSpecificStepLabel: "Condividi passaggio specifico"
      },
      issueFound: "Problema Trovato",
      complianceRiskWarningsTT: "Le notifiche di avviso di rischio ti avvertono di potenziali problemi di conformità in ogni fase del processo di due diligence. Queste notifiche aiutano a garantire che tutti i rischi vengano identificati prima di procedere alla fase successiva. Puoi abilitare o disabilitare questi avvisi in qualsiasi momento nelle Impostazioni del rapporto o durante la creazione del rapporto.",
      statusLegend: "Legenda dello Stato",
      statusLegendInfo: "La legenda dello stato fornisce una panoramica rapida dello stato attuale del rapporto di due diligence. Viene utilizzata per indicare lo stato attuale del rapporto e le azioni che possono essere intraprese per aggiornarlo.",
      sentToExporter: "Inviato all'Esportatore",
      approved: "Approvato",
      updateRequired: "Aggiornamento Richiesto",
      rejected: "Respinto",
      noExporterFound: "Nessun esportatore trovato",
      exporterFoundSuccessfully: "Esportatore trovato con successo",
      enterExporterEmail: "Inserisci l'email dell'esportatore",
      shareReport: "Condividi rapporto",
      exporterInformation: "Informazioni sull'esportatore",
      pleaseEnterExporterEmail: "Per favore, inserisci l'email dell'esportatore",

      // Activity Log translations
      activityLog: "Log delle attività",
      activityLogTT: "Log delle azioni effettuate su questo rapporto.",
      user: "Utente",
      userRole: "Ruolo utente",
      ipAddress: "Indirizzo IP",
      segment: "Segmento",
      activityDescription: "Descrizione dell'attività",
  },
  dueDiligence: {

    comments: "Commenti",
    commentsRegardingStatement: "commenti riguardanti la dichiarazione",
    countryOfProduction: "Paese di Produzione",
    countryOfProductionTT: "Paese di Produzione",
    containerId:"Id del contenitore",
    createWithoutRiskAssessment: {
      title: "Crea DDS senza valutazione del rischio",
      message: "Vuoi creare un DDS senza aggiungere una valutazione del rischio? In tal caso, le regole di controllo delle lamentele salteranno questo passaggio.",
      confirmBtnText: "Sì",
      cancelBtnText: "No",
      doNotShowAgain: "Non mostrare più questo messaggio"
    },
    noAssessmentWarning: "Il rapporto DDS manca di valutazioni dei rischi.",
    disputeReason: "Si prega di scegliere un motivo di disputa.",
    agricultureAgreement:
      "Si prega di accettare il termine prima di procedere.",
    attachDisputeFile:
      "Si prega di allegare un file prima di sollevare la disputa.",
    listOfFarmsInfo:
      "Una visualizzazione completa delle aziende agricole, comprese informazioni quali il luogo di produzione, il nome del produttore, il paese in cui opera, la superficie in ettari, il tipo di attività agricola, le valutazioni relative alla deforestazione e le valutazioni dei potenziali rischi associati alle operazioni agricole.",
    producerTT:
      "Selezione di produttori o fabbricanti coinvolti nella catena di approvvigionamento.",
    supplierInformationTT: "Dettagli sull'entità che fornisce beni o servizi.",
    operatorTooltip:
      "Seleziona l'operatore dalla lista pre-registrata nel sistema",
    supplierTooltip:
      "Seleziona il fornitore dall'elenco preregistrato nel sistema.",
    requiredAssessmentTooltip:
      "Scegliere le informazioni di valutazione necessarie.",
    internalRefNoTooltip:
      "Un identificatore univoco assegnato all'interno di un'organizzazione o sistema per fare riferimento a dati, transazioni o registri specifici a fini di tracciamento e gestione interna.",
    eudrRefNoTooltip:
      "Si riferisce a un identificatore univoco associato al Regolamento Europeo sulla Deforestazione (EUDR), generalmente utilizzato per tracciare e fare riferimento a informazioni relative alla conformità nel contesto delle normative sulla deforestazione.",
    companyIdTooltip:
      "Un identificatore distinto assegnato a un'azienda o organizzazione a fini di identificazione e tracciamento, spesso utilizzato all'interno di sistemi, database o quadri normativi.",
    placeOfActivityTooltip:
      "Specifica il paese dell'operatore in cui vengono svolte le attività e il paese in cui il prodotto entrerà nel mercato dell'UE. Questi dettagli sono essenziali per garantire il rispetto accurato dei requisiti EUDR.",
    productDetailToolTip:
      "Fornisce informazioni dettagliate sul prodotto, incluso il suo nome, massa netta, volume, nome scientifico e nome comune.",
    productToolTip:
      "Nome del prodotto. Si riferisce a un articolo o merce tangibile prodotta, fabbricata o commercializzata da un'azienda.",
    productDescToolTip:
      "Fornisce una spiegazione o un riassunto testuale delle caratteristiche, funzioni o attributi di un prodotto, con l'obiettivo di informare gli utenti o i clienti sulla sua natura o funzionalità.",
    subProductToolTip:
      "Nome del Sotto-Prodotto. Denota una categoria o sottocategoria specifica di una categoria di prodotto più ampia, generalmente utilizzata per una classificazione o differenziazione aggiuntiva all'interno di una gerarchia di prodotti.",
    netMassTooltTip:
      "Indica il peso di un prodotto o articolo, generalmente escludendo il peso dell'imballaggio o di altri materiali.",
    volumeToolTip:
      "Si riferisce alla quantità di spazio occupata da un prodotto o sostanza, generalmente misurato in unità cubiche come metri cubi o piedi cubi, utilizzato per quantificare la capacità o la quantità nello spazio tridimensionale.",
    scientificNameToolTip:
      "Nome tassonomico di un organismo che consiste nel genere e nella specie, ad esempio, Coffea Arabica, Theobroma cacao L.",
    commonNameToolTip:
      "Un nome che si basa sul linguaggio quotidiano, ad esempio, Cacao, Caffè.",
    manualProductionPlaceTooltip:
      "Processo di inserimento manuale delle località di produzione nel sistema.",
    producerNameTT:
      "Il nome di un individuo/azienda/organizzazione che crea e fornisce beni o servizi.",
    producerCountryTT: "La nazione di origine da cui proviene il produttore.",

    productionPlaceUsingLots:
      "Selezionare Luoghi di Produzione utilizzando Lotti",
    operatorSelect:
      "Operatore: Scegli questa opzione se, come operatore, sarai responsabile dell'aggiunta dei dati del luogo di produzione. Avrete la possibilità di fornire un elenco di produttori, le loro aziende agricole e le geolocalizzazioni all'interno dell'app.",
    supplierSelect:
      "Fornitore: Scegli questa opzione se il fornitore sarà responsabile dell'aggiunta dei dati del luogo di produzione. Essi avranno accesso a fornire l'elenco dei produttori, delle loro aziende agricole e delle geolocalizzazioni direttamente all'interno dell'app.",
    selectWhoWillAddPlaceData:
      "Seleziona chi aggiungerà i dati di Luogo di Produzione",
    dueDiligence: "Unione europea Due diligence",
    assementBuilder: "Costruttore di valutazione",
    assessment: "Valutazione",
    selectUsers: "Seleziona gli utenti",
    assessmentsList: "Elenco delle valutazioni",
    createAssessment: "Creare la valutazione",
    assessmentName: "Nome della valutazione",
    assessmentNameInfo:
      "Funzionalità per trovare valutazioni o informazioni specifiche.",
    searchAssessment: "Valutazione della ricerca",
    selectProcess: "Selezionare il processo di valutazione",
    assessSettings: "Impostazioni di valutazione",
    assessmentTitle: "Titolo della valutazione",
    assessmentTitleInfo: "Nome che identifica una valutazione.",
    assessDescription: "Descrizione della valutazione",
    assessDescriptionInfo:
      "Breve spiegazione dello scopo o del contenuto della valutazione.",
    describeAsessment: "Descrivere la valutazione",
    country: "Paese",
    selectCountry: "Seleziona Paese",
    expiryTime: "Tempo di scadenza",
    expiryTimeInfo:
      "Durata fino a quando la valutazione scade o diventa invalida.",
    noQuestionEachStep: "Numero di domande",
    byHeadings: "Rubriche: Dimensions, Gli uccelli",
    assessmentStatus: "Stato di valutazione",
    multiStepAssess: "Valutazione Multi-Step",
    allowAssessment:
      "Consentire la valutazione di essere risposto più di una volta",
    onlyIfExpired: "Solo se scaduto",
    atAnyTime: "In qualsiasi momento",
    editAssessmentDetails: "Modifica della domanda",
    assessmentDetail: "Dettagli di valutazione",
    addQuestion: "Aggiungi domanda di valutazione",
    attachFiles: "File di Allegato",
    digitalSignature: "Firma digitale",
    showChecklist: "Visualizza elenco",
    hideChecklist: "Nascondi la lista di controllo",
    fileType: "Tipo di file",
    allowMultipleFile: "Consentire allegati multipli",
    allowComment: "Consentire i commenti",
    uploadSignatureFile: "Registrazione di carico File",
    drawSignature: "Disegnare la firma",
    addSubHeading: "Aggiungi sotto-heading",
    heading: "Denominazione",
    headingInfo:
      "Titolo sotto il quale verrà categorizzata la domanda di valutazione. Un menu a tendina per selezionare il titolo.",
    subHeading: "Sub-Heading",
    mutiStepHeadingLable: "Creare un nuovo passo per ogni Sub-Heading",
    dueDiligenceReports: "Due rapporti di diligenza",
    manageFarms: "Gestione di aziende agricole",
    disputeResolution: "Risoluzione delle controversie",
    disputeAssessment: "Valutazione delle controversie",
    suppliers: "Fornitori",
    shipments: "Spedizioni",
    dueDiligenceGuide: "Guida di diligenza",
    multiStepQuestion1: "Creare un nuovo passo dopo",
    questions: "domande",
    questionsInfo:
      "Quantità di domande in ciascuna fase di una valutazione a più fasi.",
    selectRequiredAssessment: "Selezionare le valutazioni richieste",
    filterAssessments: "Valutazione dei filtri",
    dueDiligenceReportCreation: "Due Diligence Report Creazione",
    dueDiligenceNew: "Due diligence",
    createNewReport: "Creare un nuovo report",
    operator: "Operatore",
    supplier: "Fornitore",
    addMoreAssessments: "Aggiungere ulteriori valutazioni",
    internalReferenceNumber: "Numero di riferimento interno",
    referenceNumber: "Numero di riferimento",
    domestic: "Domestico",
    import: "Importazioni",
    export: "Esportazione",
    selectProduct: "Selezionare il prodotto",
    selectSubProduct: "Seleziona il prodotto Sub",
    addnewSupplier: "Aggiungi nuovo fornitore",
    farmDeforestationReport: "Relazione sulla deforestazione agricola",
    addProductionPlaceData: "Aggiungi i dati del luogo di produzione",
    addProductionPlaceDataTooltip: "Scegli come aggiungere i dati",
    addProductionPlaceDataDesc:
      "Crea i tuoi report integrando i dati di produzione da varie fonti. Seleziona una o più sorgenti per compilare un elenco completo dei luoghi di produzione per i tuoi report.",
    dimitraApps: "Dimitra Apps",
    addNew: "Aggiungi nuovo",
    existingData: "Dati esistenti",
    manualDataEntry: "Entrata manuale dei dati",
    importFile: "Importa file",
    connectedCoffee: "Caffè collegato",
    connectedCacao: "Cacao collegato",
    connectedFarmer: "Agricoltori collegati",
    manaulProductionPlace: "Luogo di produzione manuale",
    farmerRegistrationId: "ID di registrazione del contadino",
    farmRegistrationId: "ID di registrazione dell'agricoltore",
    manaulProductionPlaceTooltip:
      "Processo di inserimento manuale delle località di produzione nel sistema.",
    addProductionPlace: "Aggiungi il posto di produzione",
    producerName: "Nome del produttore",
    producerCountry: "Paese produttore",
    totalArea: "Superficie totale",
    number: "Numero",
    productionPlaceDesc: "Luogo di produzione Descrizione",
    area: "Area (ha)",
    type: "Tipo",
    actions: "Azioni",
    selectType: "Selezionare Tipo",
    importProductionPlace: "Produzione di importazioni Luogo",
    downloadXLSFormat: "DOWNLOAD XLS FORMAT",
    downloadGeoJsonFormat: "Scarica GeoJSON Formato",
    downloadXMLFormat: "Scarica XMLFormat",
    downloadFileFormatTemplates: "Scarica modelli di formato file",
    importantNote: "Nota importante",
    pleaseProvideFollowing: "Fornire il seguente formato (GeoJSON e XML)",
    existingProductionPlaces: "Luoghi di produzione esistenti",
    productionPlaceAndFarmID: "Luogo di produzione e Farm ID",
    selectFileToUploadData: "Selezionare il file per caricare i dati",
    filterByDate: "Filtra per data",
    dateOfRegister: "Data del registro",
    dateOfLastReport: "Data dell'ultimo rapporto",
    clearAll: "Cancella tutto",
    addLocation: "Aggiungi posizione",
    pleaseCompleteBeforeProceedingToNext:
      "Si prega di completare la sezione dettagli report prima di procedere alla fase successiva.",
    progressSavedSuccessMsg: "Progressi salvati con successo!",
    failedSavedProgress: "Non ha fatto progressi. Per favore riprovate.",
    failedToCreateReportDetails:
      "Non è riuscito a creare ReportDetails. Per favore riprovate.",
    unExpectedErrorMsg:
      "Si è verificato un errore inaspettato. Per favore riprovate.",
    selectAssessment: "Selezionare la valutazione",
    confirmationPopup: "Conferma Popup",
    confirmation: "Conferma",
    saveAndConfirmationMessage: "Sei sicuro di voler salvare i cambiamenti?",
    supplierNotRegisterContent:
      "Il Fornitore non è registrato. Vuoi inviare una notifica al fornitore per aderire alla piattaforma via e-mail?",
    confirmationPopupMsg:
      "Sei sicuro di voler scartare il rapporto? Confermare questa azione provocherà una cancellazione permanente.",
    warningPopup: "Attenzione Popup",
    warningPopupMsg:
      "Sei sicuro di voler rifiutare questo rapporto? Nota: Questi dati saranno salvati dopo il rifiuto nel caso in cui si desidera rivederlo in seguito.",
    automatedDeforestationProgressText:
      "Controllo automatico della deforestazione dei dati di geofence e identificazione dei casi critici",
    someRiskWereIdentifiedText:
      "Alcuni rischi sono stati identificati nel seguente agriturismo, si dovrebbe rivedere l'agriturismo con i rischi identificati e mitigarli prima di passare al passo successivo.",
    riskAssessmentAndMitigation: "Valutazione del rischio & Mitigation",
    riskAssessmentStatus: "Stato di valutazione del rischio",
    riskAssessment: "Valutazione del rischio",
    uploadRiskAssessment: "Valutazione del rischio di carico",
    uploadRiskAssessmentTT:
      "Azione per caricare un documento di valutazione del rischio.",
    manualFillOutAssessment: "Compilare manualmente la valutazione",
    manualFillOutAssessmentTT:
      "Azione per completare un modulo di valutazione manualmente.",
    criteria: "Criteri (b, f e g)",
    downloadAssessmentForm: "Modulo di valutazione",
    addSignature: "Aggiungi firma",
    uploadImage: "Carica immagine",
    createNewDueDiligenceProgress: "Creare un nuovo processo di due diligence",
    usageLimits: "Limiti di utilizzo",
    totalReports: "Totale relazioni",
    eudrDeforestationAssessments: "Valutazioni di deforestazione EUDR",
    totalAssessments: "Totale delle valutazioni",
    listOfFarms: "Elenco delle aziende agricole",
    perMonth: "Per mese",
    share: "Condividi",
    viewReport: "Visualizza relazione",
    viewReportSummary: "Visualizza il riepilogo del rapporto",
    copy: "Copia",
    listOfSupplier: "Elenco dei Fornitori",
    addNewSupplier: "Aggiungi nuovi fornitori",
    editSupplier: "Modifica del fornitore",
    supplierName: "Nome del fornitore",
    listOfOperators: "Elenco degli operatori",
    addNewOperator: "Aggiungi nuovi operatori",
    operatorName: "Nome operatore",
    operators: "Operatori",
    editOperator: "Modifica",
    eoriNumber: "Numero EORI",
    enterEmailAddress: "Inserisci l'indirizzo email",
    enterFirstName: "Inserisci il nome",
    enterLastName: "Inserisci il cognome",
    enterEORINumber: "Inserisci il numero EORI",
    myFarms: "Le mie fattorie",
    listOfProducers: "Elenco dei produttori",
    producers: "Produttori",
    addNewProducer: "Aggiungi nuovo produttore",
    lastAssessment: "Ultima Valutazione",
    noOfFarms: "Numero di aziende agricole",
    shipmentID: "ID spedizione",
    noOfReports: "Numero di segnalazioni",

    confirmDownload: "Vuoi scaricare tutti gli allegati in formato PDF?",

    selectProductionPlacesUsingLots:
      "Seleziona i luoghi di produzione utilizzando i lotti",
    SelectProductionPlacesUsingFarms:
      "Seleziona i luoghi di produzione utilizzando le fattorie",

    areaForPointGeofence: "Area per geofence circolare",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Secondo l'EUDR, le fattorie con meno di 4 ettari non richiedono un poligono.",
    circularAreaEquivalent:
      "In questi casi, utilizzeremo un'area circolare equivalente alla dimensione della fattoria, con il punto GPS fornito come centro per verificare la deforestazione. Se non viene fornita la dimensione della fattoria, utilizzeremo 4 ettari come impostazione predefinita.",
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow:
      "Se le fattorie sono più piccole, inserisci la dimensione standard nel campo sottostante.",
    defaultCircularGeofence:
      "Le fattorie senza geofence o senza informazioni sulla loro dimensione riceveranno un geofence circolare predefinito di 4 ettari. Se la dimensione media della fattoria è inferiore a 4 ettari, modifica la dimensione predefinita facendo clic sul pulsante 'Modifica' qui sotto.",
    defaultAreaValueSpecified:
      "Le fattorie senza geofence o area riceveranno il valore dell'area predefinito specificato di seguito e sarà assegnato un geofence circolare con un raggio circolare.",
    uploadFileBeingProcessed:
      "I file caricati sono in fase di elaborazione. Sarai reindirizzato alla pagina dell'elenco dei report di due diligence per visualizzare lo stato.",
    processingLocations: "Elaborazione delle località",

    lotId: "ID Lotto",
    lotIds: "ID Lotti",
    product: "Prodotto",
    qualityGade: "Grado di qualità",
    processingDate: "Data di elaborazione",

    importProductionPlaceTT:
      "Consente agli utenti di importare i dati del luogo di produzione utilizzando opzioni di caricamento o download dei file.",
    internalReferenceNumberTT:
      "Un numero di riferimento o codice utilizzato internamente per organizzare e gestire i report di due diligence.",

    onlyShowFarmsWithIssues: "Mostra solo le fattorie con problemi",
    analyzingStatus: "Analizzando lo Stato della Deforestazione",
    analyzingDesc:
      "Le tue fattorie stanno subendo un'analisi automatizzata sulla deforestazione. Verrai reindirizzato alla pagina dei rapporti di due diligence per vedere lo stato.",
    readyToProceed: "Pronto per Continuare",
    mitigationRequired: "Mitigazione Richiesta",
    viewSummary: "Visualizza Riepilogo",
    viewAssessment: "Visualizza Valutazione",
    disputes: "Controversie",
    manualRiskMitigation: "Mitigazione Manuale del Rischio",
    veryHighProbability: "Probabilità Molto Alta",
    highProbability: "Probabilità Alta",
    mediumProbability: "Probabilità Media",
    lowProbability: "Probabilità Bassa",
    veryLowProbability: "Probabilità Molto Bassa",
    zeroProbability: "Zero/Probabilità Trascurabile",
    manualMitigated: "Mitigato Manualmente",
    disputeDesc:
      "Fai clic su una delle controversie sottostanti per vedere i dettagli.",
    geofenceColorCode: "Codice Colore Geofence:",
    noDisputeHaveSubmitted: "Non è stata inviata alcuna controversia",
    disputeDetails: "Dettagli Controversia",
    chooseDisputeReason: "Seleziona il Motivo della Controversia",
    pleaseAttachDoc: "Allega documenti/foto per supportare la tua risposta.",
    additionalNotes: "Note Aggiuntive",
    aggrementStatement:
      "Capisco che il terreno colpito non sarà utilizzato per l'agricoltura nei prossimi anni.",
    addGeofenceRadius: "Aggiungi Raggio Geofence",
    totalGeofenceRadius: "Il Raggio Totale del Geofence è",
    resolutionHistory: "Storico delle Risoluzioni",
    proceed: "Procedi",
    wildFire: "Incendio Bosco",
    controlledFire: "Incendio Controllato",
    clearingForAgriculture: "Pulizia per Agricoltura e/o Allevamento",
    pestAndDiseases: "Parassiti e Malattie",
    naturalChangesInCanopy:
      "Cambiamenti Naturali nella Copertura (come la caduta delle foglie stagionale)",
    strongWinds: "Venti Forti (come uragani o tornado)",
    otherNaturalDisasters: "Altri Disastri Naturali",
    flooding: "Inondazioni",
    logging: "Abbattimento Alberi",
    infrastructure: "Infrastrutture",
    urbanization: "Urbanizzazione",
    landGrabbingOrPopulationPressure:
      "Esproprio della Terra, Agricoltura di Sussistenza o Pressione Demografica",
    mining: "Estrazione Mineraria",
    plantationForestBeforeDeadline:
      "È una foresta piantata o un terreno boschivo, ma le foreste primarie o le foreste naturalmente rigenerate sono state convertite in foreste piantate o in altri terreni boschivi prima della scadenza (31 dicembre 2020)",
    convertedToPlantationForest:
      "Le foreste primarie o le foreste naturalmente rigenerate sono state convertite in foreste piantate o in altri terreni boschivi",
    cultivatedAreaBeforeDeadline:
      "È un'area coltivata e non è stata deforestata dopo la scadenza (31 dicembre 2020)",
    forestStillPreserved:
      "C'è ancora una foresta nell'area, ma non è stata deforestata ed è ancora preservata",
    downloadAsPDF: "Scarica come PDF",
    downloadAsJSON: "Scarica come JSON",
    downloadOptions: "Opzioni di download",
    productionPlacesHighDeforestationProbability:
      "I luoghi di produzione hanno alta probabilità di deforestazione",
    geofenceHighDeforestationProbability:
      "Il Geofence ha alta probabilità di deforestazione",
    EUDRReferenceNumber: "Numero di Riferimento EUDR",
    commonName: "Nome Comune",
    totalNoOfRiskAssessment: "Numero Totale di Valutazioni del Rischio",
    totalNoOfHighDeforestation:
      "Numero Totale di Fattorie con Alta Probabilità di Deforestazione",
    totalNoOFDeforestationAssessments:
      "Numero Totale di Valutazioni sulla Deforestazione",
    totalNoOfFarms: "Numero Totale di Fattorie",
    totalNoOfGeofencePoints: "Numero Totale di Punti Geofence",
    totalNoOfGeofencePolygons: "Numero Totale di Poligoni Geofence",
    reportSummary: "Riepilogo del Rapporto",
    supplierData: "Dati del Fornitore",
    isoCode: "Codice ISO",
    operatorData: "Dati dell'Operatore",
    dueDiligenceReportStatus: "Stato del Rapporto di Due Diligence",
    declarationStatement: "Dichiarazione da parte dell'Operatore",
    undoDelete: "Annulla Eliminazione",
    analyzingDeforestation: "Analizzando la Deforestazione",
    processingFarm: "Elaborazione Fattoria",
    createShipment: "_Crea nuova spedizione_",
    addStop: "_Aggiungi una parola_",
    stop: "_Parola_",
    enterStop: "_Inserisci una parola_",
    logistics: "Logistica",

    netMassKG: "Massa Netta (kg)",
    volumeM3: "Volume (m3)",
    areaInHA: "Superficie (ha)",
    supplierTT:
      "Selezione di fornitori o produttori coinvolti nella catena di approvvigionamento.",
    pleaseSelectAtLeastOneItem: "Seleziona almeno un elemento.",

    pleaseSelectAtLeastOneSource: "Si prega di selezionare almeno una fonte.",
    invalidFileFormatPleaseUploadValidFile:
      "Formato file non valido. Si prega di caricare un file .xml, .kml o .geojson.",
    pleaseUploadAValidFile: "Si prega di caricare un file valido.",
    fileUploadedDuccessfully: "File caricato con successo!",
    anErrorOccured: "Si è verificato un errore.",
    successfullyUpdatedDefaultFarmArea:
      "Area agricola predefinita aggiornata con successo.",
    pleaseAddProductionPlacesData:
      "Si prega di aggiungere i dati dei luoghi di produzione.",
    failedToFetchSettings: "Errore nel recupero delle impostazioni.",
    updatedDueDiligenceReport: "Rapporto di due diligence aggiornato.",
    updatedDueDiligenceStatus:
      "Lo stato della Due Diligence è stato aggiornato con successo.",
    failedToWriteDeforestationDataToBlockchain:
      "Errore nella scrittura dei dati di deforestazione sulla blockchain, si prega di riprovare.",
    countryIsRequired: "Il paese è obbligatorio",
    dueDiligenceReportsInfo:
      "Documentazione dettagliata che riassume i risultati e gli esiti del processo di due diligence. Questi rapporti forniscono informazioni sull'analisi condotta, inclusi i rischi identificati, lo stato di conformità e le raccomandazioni per la mitigazione o il miglioramento.",
    listOfFarmsTT:
      "Una visualizzazione completa delle fattorie, inclusi informazioni come la posizione di produzione, il nome del produttore, il paese di operazione, l'area terrestre in ettari, il tipo di attività agricole, valutazioni relative alla deforestazione e valutazioni dei rischi potenziali associati alle operazioni agricole.",

    download: "Scarica",
    print: "Stampa",
    loading: "Caricamento...",
    view: "Visualizza",

    loadingPleaseWait: "Caricamento... Attendere prego",
    existingProductionPlacesTT:
      "Mostra un elenco dei luoghi di produzione esistenti insieme a dettagli come il nome del produttore, paese, area, tipo e stato della valutazione.",
    successfullyGeneratedEUDRDeforestationStatus:
      "Lo stato di deforestazione di EUDR è stato generato con successo.",
    riskAssessmentAndMitigationTT:
      "Identificare i rischi potenziali e implementare strategie per ridurre al minimo il loro impatto o la probabilità che si verifichino. Include la valutazione dei pericoli, l'analisi delle loro possibili conseguenze e lo sviluppo di piani per affrontarli o mitigarli efficacemente.",

    eudrRefNoTT:
      "Un identificatore univoco assegnato a ciascun rapporto di due diligence, facilitando il tracciamento e la verifica della conformità all'interno del quadro del Regolamento Europeo sulla Deforestazione (EUDR).",

    operatorDataTT: "Informazioni sull'operatore.",
    supplierDataTT: "Informazioni sul fornitore.",
    reportSummaryTT: "Breve panoramica del rapporto.",
    totalNoOfGeofencePolygon: "Numero Totale di Poligoni di Geofence",
    totalNoOfGeofencePolygonTT: "Conteggio totale dei poligoni di geofence.",
    totalNoOfGeofencePoint: "Numero Totale di Punti di Geofence",
    totalNoOfGeofencePointTT: "Conteggio totale dei punti di geofence.",
    totalNoOfFarmsTT: "Conteggio totale delle fattorie.",
    totalAreaFinalReport: "Superficie Totale (ha)",
    totalNoOfDeforestation: "Numero Totale di Deforestazioni",
    totalNoOfDeforestationTT:
      "Conteggio totale delle valutazioni di deforestazione.",
    totalNoOfHighDeforestationTT:
      "Conteggio totale delle fattorie con alta deforestazione.",
    totalNoOfRiskAssessments: "Numero Totale di Valutazioni del Rischio",
    totalNoOfRiskAssessmentsTT:
      "Conteggio totale delle valutazioni del rischio.",
    productDetail: "Dettagli del Prodotto",
    productDetailTT: "Informazioni sul prodotto.",
    productTT:
      "Nome del prodotto. Si riferisce a un articolo tangibile o una merce prodotta, fabbricata o commercializzata da un'azienda o organizzazione, spesso categorizzata in base al tipo, alle caratteristiche o allo scopo.",
    productDescription: "Descrizione del Prodotto",
    productDescriptionTT:
      "Fornisce una spiegazione o un riassunto testuale delle caratteristiche, funzioni o attributi di un prodotto, con l'obiettivo di informare gli utenti o i clienti sulla sua natura o funzionalità.",
    netMass: "Peso Netto",
    netMassTT:
      "Indica il peso di un prodotto o articolo, normalmente escludendo il peso dell'imballaggio o altri materiali associati, spesso espresso in unità di massa come chilogrammi o libbre.",
    volume: "Volume",
    volumeTT:
      "Si riferisce alla quantità di spazio occupata da un prodotto o una sostanza, solitamente misurata in unità cubiche come metri cubi o piedi cubi, utilizzata per quantificare la capacità o la quantità nello spazio tridimensionale.",
    scientificName: "Nome Scientifico",
    scientificNameTT:
      "Nome tassonomico di un organismo che comprende il genere e la specie, ad esempio Coffea Arabica, Theobroma cacao L.",
    commonNameTT:
      "Un nome basato sul linguaggio quotidiano, ad esempio Cacao, Caffè.",
    successfullyUploadedToTheBlockchain:
      "Successo! Il Rapporto di Due Diligence EUDR è stato caricato con successo sulla Blockchain.",
    complianceRiskWarning: "Avviso di Rischio di Conformità",
    issueIdentifiedOnFarms:
      "Sono stati identificati problemi in alcune fattorie che richiedono attenzione prima di procedere al passaggio successivo. Puoi scegliere di affrontare questi problemi ora o continuare al passaggio successivo e risolverli in seguito.",
    blockchainDescs: [
      "Caricando il rapporto sulla blockchain, attendere...",
      "Il tuo rapporto di Due Diligence è in fase di caricamento sulla blockchain. Verrai reindirizzato alla pagina dell'elenco dei rapporti di Due Diligence per visualizzare lo stato.",
    ],
    eudrUploadedToBlockChain:
      "Successo! Il Rapporto di Due Diligenza EUDR è stato caricato con successo sulla Blockchain.",
    viewDeforestationAssessment:
      "Visualizza la valutazione della deforestazione",
    viewDeforestationCertificate: "Visualizza il certificato di deforestazione",
    selectCountries: "Seleziona Paesi",
    writingToBlockchain: "Scrittura sulla Blockchain",
    reportDownloadedSuccessfully: "Rapporto scaricato con successo!",
    operatorDecleration: "Dichiarazione dell'Operatore",
    supplierDecleration: "Dichiarazione del Fornitore",
    fRinternalReferenceNumberTT:
      "Un numero di riferimento interno è un identificatore unico assegnato a un rapporto di due diligence all'interno del sistema.",
    deleteProductionPlaceData: "Elimina i dati del luogo di produzione",
    areYouSureYouWantToContinueThisAction:
      "Sei sicuro di voler continuare questa azione?",
    noAssessment: "Nessuna Valutazione",

    cattle: "Bovini",
    coffee: "Caffè",
    cocoa: "Cacao",
    wood: "Legno",
    soya: "Soia",
    rubber: "Gomma",
    oilPlam: "Olio di palma",

    subProduct1: "0102 21 , 0102 29 Bovini vivi",
    subProduct2: "0201 Carne bovina, fresca o refrigerata",
    subProduct3: "0202 Carne bovina, congelata",
    subProduct4:
      "0206 10 Frattaglie commestibili di bovini, fresche o refrigerate",
    subProduct5: "0206 22 Fegati di bovini commestibili, congelati",
    subProduct6:
      "0206 29 Frattaglie commestibili di bovini (escluse lingue e fegati), congelate",
    subProduct7:
      "1602 50 Altre preparazioni e conserve di carni, frattaglie, sangue di bovini",
    subProduct8:
      "4101 Cuoi e pelli gregge di bovini (freschi, oppure salati, secchi, calcinati, piclati o altrimenti conservati, ma non conciati, né pergamenati né altrimenti preparati), anche depilati o spaccati",
    subProduct9:
      "4104 Cuoi e pelli depilati, conciati o in crosta, di bovini, anche spaccati, ma non altrimenti preparati",
    subProduct10:
      "4107 Cuoi di bovini, preparati dopo la concia o l'essiccazione, compresi i cuoi pergamenati, depilati, anche spaccati, diversi dal cuoio della voce 4114",
    subProduct11: "1801 Fave di cacao, intere o spezzate, crude o tostate",
    subProduct12: "1802 Gusci, bucce, bucce e altri scarti di cacao",
    subProduct13: "1803 Pasta di cacao, anche sgrassata",
    subProduct14: "1804 Burro, grasso e olio di cacao",
    subProduct15:
      "1805 Cacao in polvere, senza aggiunta di zuccheri o di altri dolcificanti",
    subProduct16:
      "1806 Cioccolata e altre preparazioni alimentari contenenti cacao",
    subProduct17:
      "0901 Caffè, anche torrefatto o decaffeinato; bucce e pellicole di caffè; succedanei del caffè contenenti caffè in qualsiasi proporzione",
    subProduct18: "1207 10 Noci e semi di palma",
    subProduct19:
      "1511 Olio di palma e sue frazioni, anche raffinati, ma non modificati chimicamente",
    subProduct20:
      "1513 21 Oli greggi di palmisti e di babassu e loro frazioni, anche raffinati, ma non modificati chimicamente",
    subProduct21:
      "1513 29 Oli di palmisti e di babassu e loro frazioni, anche raffinati, ma non modificati chimicamente (escluso il petrolio greggio)",
    subProduct22:
      "2306 60 Panelli ed altri residui solidi di noci o di semi di palma, anche macinati o agglomerati in forma di pellet, provenienti dall'estrazione dei grassi o degli oli di noci o di semi di palma",
    subProduct23:
      "2905 45 Glicerolo, con purezza pari o superiore al 95 % (calcolato sul peso del prodotto secco)",
    subProduct24:
      "2915 70 Acido palmitico, acido stearico, loro sali e loro esteri",
    subProduct25:
      "2915 90 Acidi monocarbossilici aciclici saturi, loro anidridi, alogenuri, perossidi e perossiacidi; loro derivati ​​alogenati, solfonati, nitrati o nitrosi (esclusi acido formico, acido acetico, acidi mono-, di- o tricloroacetici, acido propionico, acidi butanoici, acidi pentanoici, acido palmitico, acido stearico, loro sali e loro esteri e anidride acetica)",
    subProduct26: "3823 11 Acido stearico industriale",
    subProduct27: "3823 12 Acido oleico industriale",
    subProduct28:
      "3823 19 Acidi grassi monocarbossilici industriali; oli acidi provenienti dalla raffinazione (esclusi acido stearico, acido oleico e acidi grassi del tallolio)",
    subProduct29: "3823 70 Alcoli grassi industriali",
    subProduct30:
      "4001 Gomma naturale, balata, guttaperca, guayule, chicle e gomme naturali simili, in forme primarie o in lastre, fogli o nastri",
    subProduct31:
      "4005 Gomma mescolata, non vulcanizzata, in forme primarie o in lastre, fogli o nastri",
    subProduct32:
      "4006 Gomma non vulcanizzata in altre forme (ad esempio barre, tubi e profilati) e articoli (ad esempio dischi e anelli)",
    subProduct33: "4007 Filo e corda di gomma vulcanizzata",
    subProduct34:
      "4008 Lastre, fogli, nastri, bacchette e profilati, di gomma vulcanizzata diversa dalla gomma dura",
    subProduct35:
      "4010 Nastri trasportatori o cinghie di trasmissione, di gomma vulcanizzata",
    subProduct36: "4011 Pneumatici nuovi, di gomma",
    subProduct37:
      "4012 Pneumatici ricostruiti o usati, di gomma; gomme piene o semipiene, battistrada e protettori per pneumatici, di gomma",
    subProduct38: "4013 Camere d'aria, di gomma",
    subProduct39:
      "4015 Articoli di abbigliamento ed accessori di abbigliamento (compresi guanti, muffole e manopole), per tutti gli usi, di gomma vulcanizzata diversa dalla gomma indurita",
    subProduct40:
      "4016 Altri lavori di gomma vulcanizzata diversa dalla gomma indurita, non nominati altrove nel capitolo 40",
    subProduct41:
      "4017 Gomma dura (ad esempio ebanite) in tutte le forme, compresi cascami e avanzi; articoli di gomma dura",
    subProduct42: "1201 Semi di soia, anche frantumati",
    subProduct43: "1208 10 Farina e semolino di semi di soia",
    subProduct44:
      "1507 Olio di semi di soia e sue frazioni, anche raffinati, ma non modificati chimicamente",
    subProduct45:
      "2304 Panelli ed altri residui solidi, anche macinati o agglomerati in forma di pellet, dell'estrazione dell'olio di soia",
    subProduct46:
      "4401 Legna da ardere in tondelli, ceppi, ramaglie, fascine o in forme simili; legno in scaglie o particelle; segatura, avanzi e cascami di legno, anche agglomerati in forma di ceppi, mattonelle, palline o in forme simili",
    subProduct47:
      "4402 Carbone di legna (compreso il carbone di gusci o di noci), anche agglomerato",
    subProduct48:
      "4403 Legno grezzo, anche privato della corteccia, dell'alburno o squadrato",
    subProduct49:
      "4404 Cerchio; poli divisi; pali, picchetti e pali di legno, appuntiti ma non segati longitudinalmente; bastoni di legno sgrossati ma non torniti, piegati o altrimenti lavorati, atti alla fabbricazione di bastoni da passeggio, ombrelli, manici di utensili o simili; trucioli e simili",
    subProduct50: "4405 Lana di legno; farina di legno",
    subProduct51: "4406 Traversine ferroviarie o tranviarie di legno",
    subProduct52:
      "4407 Legno segato o tagliato per il lungo, tranciato o sfogliato, anche piallato, levigato o incollato con giunture di testa, di spessore superiore a 6 mm",
    subProduct53:
      "4408 Fogli da impiallacciatura (compresi quelli ottenuti mediante tranciatura di legno stratificato), di compensato o di altro legno simile stratificato e altro legno, segati per il lungo, tranciati o sfogliati, anche piallati, levigati, giuntati o incollati di testa, di spessore non superiore a superiore a 6 mm",
    subProduct54:
      "4409 Legno (compresi listelli e fregi per parquet, non assemblati) sagomato con continuità (con linguette, scanalati, con battuta, smussato, con giunture a V, bordato, modellato, arrotondato o simili) lungo qualsiasi dei suoi bordi, estremità o facce, anche non piallato, levigato o giuntato",
    subProduct55:
      "4410 Pannelli di particelle, pannelli a scaglie orientate (OSB) e pannelli simili (per esempio: waferboard) di legno o di altre materie legnose, anche agglomerati con resine o altre sostanze leganti organiche",
    subProduct56:
      "4411 Pannelli di fibre di legno o di altre materie legnose, anche legati con resine o altre sostanze organiche",
    subProduct57:
      "4412 Compensati, pannelli impiallacciati e legno lamellare simile",
    subProduct58:
      "4413 Legno densificato, in blocchi, lastre, listelli o profilati",
    subProduct59:
      "4414 Cornici in legno per quadri, fotografie, specchi o oggetti simili",
    subProduct60:
      "4415 Casse, cassette, gabbie, cilindri ed imballaggi simili, di legno; tamburi per cavi in ​​legno; palette, palette-cassone ed altre tavole da carico, di legno;",
    subProduct61:
      "sponde di pallet in legno (escluso il materiale da imballaggio utilizzato esclusivamente come materiale da imballaggio per sostenere, proteggere o trasportare un altro prodotto immesso sul mercato)",
    subProduct62:
      "4416 Botti, botti, tini ed altri lavori da bottaio e loro parti, di legno, comprese le doghe",
    subProduct63:
      "4417 Utensili, corpi di utensili, manici di utensili, corpi e manici di scope o spazzole, di legno; forme e alberi per stivali o scarpe, di legno",
    subProduct64:
      "4418 Falegnameria e carpenteria in legno, compresi pannelli cellulari di legno, pannelli assemblati per pavimenti, scandole e traverse",
    subProduct65: "4419 Stoviglie e utensili da cucina, di legno",
    subProduct66:
      "4420 Legno intarsiato e intarsiato; cofanetti e astucci per gioielli, coltellerie e oggetti simili, di legno; statuette ed altri ornamenti di legno; oggetti di arredamento in legno che non rientrano nel capitolo 94",
    subProduct67: "4421 Altri lavori di legno",
    subProduct68:
      "Paste e carta dei capitoli 47 e 48 della nomenclatura combinata, ad eccezione dei prodotti a base di bambù e dei prodotti di recupero (cascami e avanzi)",
    subProduct69:
      "49 Libri stampati, giornali, immagini e altri prodotti dell'industria tipografica, manoscritti, dattiloscritti e piani di carta",
    subProduct70:
      "9401 Posti a sedere (diversi da quelli della voce 9402), anche trasformabili in letti, e loro parti, di legno",
    subProduct71:
      "9403 30 , 9403 40 , 9403 50 , 9403 60 e 9403 91 Mobili in legno e loro parti",
    subProduct72: "9406 10 Costruzioni prefabbricate in legno",

    compilanceRiskWarning: "Avviso di Rischio di Conformità",
    operatorDeclerationTT: "Dichiarazione di dichiarazione dell'operatore.",
    supplierDeclerationTT: "Declaração de declaração do fornecedor.",

    blockchainVerification: "Verifica Blockchain",
    scanQrBlockchain:
      "Scansiona questo codice QR per visualizzare il rapporto di due diligence EUDR sulla blockchain.",
    downloadQrCode: "Scarica codice QR",
    eudrPublicReport: "Rapporto pubblico sulla due diligence di Dimitra EUDR",
    scanQrEudr:
      "Scansiona questo codice QR per visualizzare il rapporto di due diligence EUDR sul web pubblico.",
    viewReportForPublic: "Fai clic qui per visualizzare il rapporto pubblico",
    viewReportOnBlockChain:
      "Fai clic qui per visualizzare il rapporto sulla blockchain",
    riskAssessmentNotApproved: "i luoghi di produzione non sono approvati.",

    declarationMissing: "Dichiarazione Mancante",
    removeRiskFarms: "RIMUOVI FATTORIE A RISCHIO",
    disregardRiskDocument: "IGNORA FATTORIE A RISCHIO",
    attachRiskMitigationDocumentForNonCompliantFarms: "ALLEGARE DOCUMENTO DI MITIGAZIONE DEL RISCHIO PER TUTTE LE FATTORIE NON CONFORMI",
    uploadMitigationDocumentForNonCompliantFarms: `Caricare un documento di mitigazione del rischio per tutte le fattorie non conformi cambierà lo stato delle fattorie con "Mitigazione Necessaria" a "Mitigato Manualmente".`,
    disregardFarmWithIssuesTitle: "Ignora le aziende agricole con problemi",
    disregardFarmWithIssuesMessage: "Selezionando \"Ignora\", lo stato mancante della valutazione del rischio per le aziende agricole non sarà considerato in questo rapporto. Le aziende resteranno incluse nel rapporto, ma le valutazioni in sospeso non influiranno sullo stato di conformità. Conferma di voler procedere.",
    removeRiskFarmTitle: "Rimuovi aziende agricole",
    removeRiskFarmMessage: "Selezionando \"Rimuovi\", le aziende agricole con stato di valutazione del rischio \"Mitigazione richiesta\" o \"Rifiutato\" saranno rimosse da questo rapporto. Conferma di voler procedere.",

    fileName: "Nome del file",
    dateAndTime: "Data e ora",
    downloadProgressStatus: "Stato di avanzamento del download",
    downloadHistory: "Cronologia dei download",
    downloaded: "Scaricato",
    inprogress: "In corso",
    failed: "Fallito",
    showAllDownloads: "Mostra tutti i download",
    inProgress: "In corso",
    downloadCompleted: "Download completato",
    downloadFailed: "Download fallito",
    errorDeletingItem: "Impossibile eliminare l'elemento. Riprova più tardi.",
    anErrorOccuredPlsTryAgain: "Si è verificato un errore. Per favore riprova.",
    invalidData: "I dati forniti non sono validi. Controlla e riprova.",
    fileIsReady: "Il file è pronto per l'uso",
    invalidFilePathOrUrl: "Il percorso o l'URL del file non è valido.",
    errorDownloadingFile: "Si è verificato un problema durante il download del file. Per favore riprova.",
    downloadInitiated: "Download avviato",
    beingDownloaded: "è in fase di download. Tempo stimato",


    multiStepSurveyDetails: "In base al numero di domande in un passaggio, tutte le domande del sondaggio saranno raggruppate e visualizzate in passaggi. Tuttavia, questa configurazione è disponibile solo prima di aggiungere domande o sottotitoli. Una volta aggiunta una domanda o un sottotitolo, la configurazione a più passaggi verrà automaticamente disabilitata. Si prega di rimuovere eventuali domande o sottotitoli per riabilitare questa opzione.",
    estimatedTime: "Tempo stimato",
    tryAgain: "Riprova",
    iyb: {
      importSpreadsheetTitle: "Importa foglio di calcolo punteggi IYB",
      uploadFile: "Carica file",
      previewData: "Anteprima dati",
      confirmImport: "Conferma importazione",
      uploadPtsiSpreadsheet: "Carica foglio PTSI",
      uploadDescription: "Carica il foglio IYBv2 BOGOR fornito da PTSI. Questo file contiene lo stato di rischio EUDR e 13 punteggi indicatori per tutte le 514 reggenze indonesiane.",
      acceptedFormats: "Formati accettati",
      or: "o",
      clickOrDragFileHere: "Fai clic o trascina qui il file IYBv2 BOGOR",
      acceptsCsvOrXlsx: "Accetta .csv o .xlsx",
      dataYear: "Anno dati",
      selectYearHint: "Seleziona l'anno rappresentato da questi dati IYB. I dati degli anni precedenti saranno mantenuti.",
      previewImportData: "Anteprima dati di importazione",
      showingRows: "Visualizzazione righe {from} - {to}",
      totalRegenciesFound: "Totale reggenze trovate",
      records: "record",
      firePreventionTooltip: "Incendi Forestali e Territoriali (IYBv2 BOGOR ind2). Per l'Olio di Palma: Rosso (≤40) blocca l'invio DDS.",
      lowRiskFastTrack: "Rischio basso → VERDE (corsia veloce)",
      mediumRiskMitigation: "Rischio medio → GIALLO (mitigazione)",
      highRiskAppealPath: "Rischio alto → ROSSO (percorso di appello)",
      proceedToConfirm: "Procedi alla conferma",
      confirmImportDescription: "L'importazione aggiungerà o aggiornerà i punteggi IYB per {total} reggenze per l'anno {year}. I punteggi degli altri anni non saranno influenzati.",
      totalRegencies: "Totale reggenze",
      importNow: "Importa ora",
      regencyId: "ID reggenza",
      regencyName: "Nome reggenza",
      iybScore: "Punteggio IYB",
      firePrevention: "Prevenzione incendi",
      eudrRiskStatus: "Stato rischio EUDR",
      iybScores: "Punteggi IYB",
      importSpreadsheet: "Importa foglio di calcolo",
      noDataFound: "Nessun dato trovato",
      noValidRegencyRows: "Il foglio non conteneva righe di reggenza valide.",
      previewFailed: "Anteprima non riuscita",
      couldNotParseSpreadsheet: "Impossibile analizzare il foglio",
      couldNotLoadPreviewPage: "Impossibile caricare la pagina di anteprima",
      importSuccessTitle: "Punteggi IYB importati con successo",
      regenciesImported: "{count} reggenze importate",
      importFailed: "Importazione non riuscita",
      couldNotImportSpreadsheet: "Impossibile importare il foglio",
      iybRegionalScores: "Punteggi regionali IYB",
      iybRegionalScoresSubtitle: "Punteggi indicatori di giurisdizione sostenibile a livello di reggenza, provenienti da PTSI. Usato per la Fase 2 del controllo EUDR Traffic Light.",
      allIndonesiaDistricts: "Tutti i distretti dell'Indonesia",
      greenLowRisk: "VERDE — Rischio basso",
      fastTrackEligible: "Idoneo corsia veloce",
      yellowMediumRisk: "GIALLO — Rischio medio",
      mitigationRequired: "Mitigazione richiesta",
      redHighRisk: "ROSSO — Rischio alto",
      blockedAppealPath: "Bloccato, percorso di appello disponibile",
      searchRegencyName: "Cerca nome reggenza...",
      filterByTier: "Filtra per livello",
      year: "Anno",
      details: "Dettagli",
      failedToLoadScores: "Impossibile caricare i punteggi IYB",
      indicatorBreakdownTitle: "Dettaglio indicatori IYB",
      regencyKabupaten: "Reggenza / Kabupaten",
      environmental: "Ambientale",
      socialAgricultural: "Sociale e Agricolo",
      governance: "Governance",
      scoreRanges: "Intervalli di punteggio:",
      lowRiskRange: "Rischio basso (≥60)",
      mediumRiskRange: "Rischio medio (40.01–59.99)",
      highRiskRange: "Rischio alto (≤40)",
      indicators: {
        spatialPlanning: "Pianificazione spaziale",
        forestLandFires: "Incendi forestali e territoriali",
        waterWaste: "Acqua e rifiuti",
        climateAction: "Azione climatica",
        landExploitation: "Sfruttamento del suolo",
        independentSmallholders: "Piccoli agricoltori indipendenti",
        farmerInstitutions: "Istituzioni agricole",
        businessPartnerships: "Partnership aziendali",
        indigenousCommunities: "Comunità indigene",
        gender: "Genere",
        spbeInformation: "Informazioni SPBE",
        sp4nLaporComplaints: "Reclami SP4N-LAPOR",
        fpicSop: "SOP FPIC",
      },
    }


  },
  diligenceGuide: {
    guide: "Guida",
    downloadPdfManual: "Scarica Manuale in PDF",
    watchDemoVideo: "Guarda Video Dimostrativo",
    viewManualOnWeb: "Visualizza Manuale sul Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Il Tuo Hub di Guide Essenziali",
    description: `Esplora la nostra pagina delle Guide di Supporto del Sistema di Due Diligence EUDR
          per risorse essenziali, inclusi manuali in PDF, video tutorial e assistenza
          basata sul web. Dai a te stesso gli strumenti per navigare nella piattaforma in modo efficiente
          e ottimizza il tuo flusso di lavoro.`,
    continueToTheDueDiligenceSystem: "Continua al Sistema di Due Diligence",
  },

  containerTypes: {
    standardDry: "Contenitore Secco Standard (20ft, 40ft)",
    highCube: "Contenitore Cubo Alto",
    openTop: "Contenitore Aperto",
    flatRack: "Contenitore a Pianale",
    refrigerated: "Contenitore Refrigerato (Reefer)",
    tank: "Contenitore Cisterna",
    ventilated: "Contenitore Ventilato",
    insulated: "Contenitore Isolato",
    platform: "Contenitore Piattaforma",
    halfHeight: "Contenitore a Mezza Altezza",
    bulk: "Contenitore alla Rinfusa",
  },
  assessmentStatus:{
    riskAssessmentSummary: "Riepilogo della Valutazione dei Rischi",
    riskAssessmentSummaryTT: "Riepilogo della Valutazione dei Rischi",
    totalNoOfFarms: "Numero Totale di Fattorie",
    assessmentsCompleted: "Valutazioni Completate",
    assessmentsPending: "Valutazioni In Sospeso",
    requiredMitigation: "Mitigazione Richiesta",
  }
};
